import "../CSS/Skill.css";
import React, { useState, useEffect, useRef } from "react";
import Icon from "@mdi/react";
import { mdiXml } from "@mdi/js";
import ProgressBar from "@ramonak/react-progress-bar";
import axios from "axios";
import Preload from "./Preload";
import { gsap } from "../animations/gsap";
import { useLoadingContext } from "../context/LoadingContext";

const apiUrl = process.env.REACT_APP_API_URL;

function Skill() {
  const [skills, setSkill] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const listRef = useRef(null);
  const { register, done } = useLoadingContext();

  useEffect(() => {
    register();
    axios
      .get(apiUrl + "skills")
      .then((response) => {
        setSkill(response.data);
        setIsLoading(false);
      })
      .catch(console.error)
      .finally(done);
  }, [done, register]);

  useEffect(() => {
    if (isLoading || !listRef.current) return;
    const items = listRef.current.querySelectorAll("li");

    const tween = gsap.fromTo(
      items,
      { opacity: 0, x: -50 },
      {
        opacity: 1,
        x: 0,
        duration: 0.5,
        stagger: 0.08,
        ease: "power2.out",
        scrollTrigger: {
          trigger: listRef.current,
          start: "top 80%",
          once: true,
        },
      },
    );
    return () => {
      tween?.scrollTrigger?.kill();
      tween?.kill();
    };
  }, [isLoading]);

  if (isLoading) return <Preload />;

  return (
    <div id="skills" className="content_box">
      <h1 className="content_box_title">
        <Icon path={mdiXml} className="Main_Icons" size={1} />
        Skills
      </h1>
      <div className="Skills">
        <ul ref={listRef} className="Skill_List">
          {skills.map((skill) => (
            <li key={skill.id} style={{ opacity: 0 }}>
              <div>
                <label className="Skill_Label">
                  <i className={skill.icon}></i>
                  {skill.name}
                </label>
                <ProgressBar
                  completed={skill.percentage}
                  bgColor="#20CE65"
                  height="6px"
                  borderRadius="3px"
                  labelAlignment="center"
                  baseBgColor="#19232B"
                  labelSize="0"
                  margin="0"
                  padding="0"
                  transitionDuration="2s"
                  transitionTimingFunction="ease"
                  animateOnRender
                  maxCompleted={100}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
export default Skill;
